export class Recipe {
  public notes: string = "";
  constructor(public name: string, public url: string){}
}



// WEBPACK FOOTER //
// /Users/Guest/Desktop/Food-Savor/src/app/recipe.model.ts